<template>
  <div id="nav-bar">
    <component :is="dynamicComponent"></component>
  </div>
</template>

<script>
import deviceMixins from "../mixins/deviceMixins";
import MobileNavBar from "./mobile/NavBar";
import DesktopNavBar from "./desktop/NavBar";

export default {
  mixins: [deviceMixins("NavBar")],
  components: {
    MobileNavBar,
    DesktopNavBar
  }
};
</script>


<style scoped>
#nav-bar {
  width: 100%;
}
</style>>
